import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=e06187b2&scoped=true"
import script from "./HistoryPage.vue?vue&type=script&lang=js"
export * from "./HistoryPage.vue?vue&type=script&lang=js"
import style0 from "./HistoryPage.vue?vue&type=style&index=0&id=e06187b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06187b2",
  null
  
)

export default component.exports